export default __webpack_public_path__ + "static/media/close.4d0a0a5d.png";